// Datas do histórico de disparo.
//
// A pergunta que a tela responde é "quando isso saiu?", e a resposta útil muda
// com a distância: hoje se lê pela hora, semana passada se lê pelo dia. Por
// isso o rótulo do dia e a hora são formatados separados — e o timestamp
// completo fica no title, para quem precisa do minuto exato.

const HOJE = 'OUTBOUNDS.HISTORY.WHEN.TODAY';
const ONTEM = 'OUTBOUNDS.HISTORY.WHEN.YESTERDAY';

function startOfDay(date) {
  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);
  return copy;
}

export function parseDate(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

// "Hoje" / "Ontem" / "18/08/2026". Devolve a chave de i18n quando é relativo,
// para o componente traduzir — nada de string em português vazando do helper.
export function dayLabel(value, t) {
  const date = parseDate(value);
  if (!date) return '—';

  const diffDays = Math.round(
    (startOfDay(new Date()) - startOfDay(date)) / 86400000
  );
  if (diffDays === 0) return t(HOJE);
  if (diffDays === 1) return t(ONTEM);
  return date.toLocaleDateString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function timeLabel(value) {
  const date = parseDate(value);
  if (!date) return '';
  return date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Rótulo curto para a coluna "último disparo": dia + hora numa linha só.
export function whenLabel(value, t) {
  const date = parseDate(value);
  if (!date) return '—';
  return `${dayLabel(value, t)} ${timeLabel(value)}`;
}

export function fullTimestamp(value) {
  const date = parseDate(value);
  return date ? date.toLocaleString() : '';
}

// Agrupa a linha do tempo de uma pessoa por dia, do mais recente para o mais
// antigo, preservando a ordem que veio do backend dentro de cada dia.
export function groupByDay(posts, t) {
  const groups = [];
  posts.forEach(post => {
    const label = dayLabel(post.sent_at, t);
    const last = groups[groups.length - 1];
    if (last && last.label === label) {
      last.items.push(post);
      return;
    }
    groups.push({ label, items: [post] });
  });
  return groups;
}

// Um disparo tem três desfechos e cada um pede uma cor diferente: entregue à
// Meta, recusado por ela, e nem tentado.
export function statusTone(status) {
  if (status === 'ENVIADO') return 'teal';
  if (status === 'ERRO') return 'ruby';
  return 'amber';
}
